import React from "react"
import styled, { css } from "styled-components"

import { Typography } from "@material-ui/core"

// import HeroImage from "../../../components/HeroImage"

import BackgroundImage from "../../../components/BackgroundImage"

import Arrow from "../../../images/arrow_forward.svg"

import * as theme from "../../../theme"

export default function LinkBox(props) {
  const { image, headline, to, link, ...rest } = props
  const url = (link && link.url) || to

  return (
    <Item {...rest} href={url} target={link && link.target}>
      <Content>
        <Headline className="headline" variant="h2">
          {headline}
        </Headline>
        <Arrow />
      </Content>
      <BgImage
        className="background-image"
        bg={image?.url || image}
        position="absolute"
      />
    </Item>
  )
}

const Item = styled.a`
  ${({ count }) =>
    count > 2
      ? css`
          @media (min-width: 1100px) {
            width: calc(100% / 3 - 5px);
          }
        `
      : css`
          @media (min-width: 350px) {
            width: calc(100% / 2 - 5px);
          }
        `}

  @media (min-width: 350px) and (max-width: 1099px) {
    width: calc(100% / 2 - 5px);
  }
  width: 100%;

  position: relative;
  text-decoration: none;
  min-height: 120px;
  padding: 90px 20px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0;

  &:hover {
    .headline {
      transform: translateY(-10%);
    }
    svg {
      transform: translateY(50%);
      opacity: 1;
    }
    .background-image {
      &::before {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }
`

const Content = styled.div`
  .headline {
    transition: all 150ms ease-in-out;
  }
  position: relative;
  z-index: 2;

  svg {
    transition: all 150ms ease-in-out;
    fill: white;
    position: absolute;
    left: calc(50% - 12px);
    top: 100%;

    transform: translateY(100%);
    opacity: 0;
  }
`
const Headline = styled(Typography)`
  && {
    color: white;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
  }
`

const BgImage = styled(BackgroundImage)`
  &::before {
    z-index: 1;
    content: "";
    background: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 150ms ease-in-out;
  }
`
